import type { AuthWebappPermissionAtom } from "@/gen/orval/webplatform/model/authWebappPermissionAtom.gen";

/**
 * Pure AND-check helper, extracted so it can be unit-tested directly.
 * Mirrors monorepo packages/permissions/checkPermissions used on the backend.
 *
 * `granted` stays `readonly string[]` (raw JWT claims) so this stays
 * forward-compatible if the backend issues atoms the FE doesn't know yet.
 * `required` is typed against the canonical atom union so callers can't
 * typo an atom name.
 */
export function hasAllPermissions(granted: readonly string[], required: readonly AuthWebappPermissionAtom[]): boolean {
  return required.every((atom) => granted.includes(atom));
}
